import React from "react";
import { compose } from "redux";
import { Grid, Button } from "@material-ui/core";

import { LoadingButton } from "altus-ui-components";

import { EMPLOYEE_COURSE_FORM } from "features/competence.constants";

const EmployeeCourseModalActions = ({
  tabs,
  valid,
  change,
  activeTab,
  submitText,
  submitting,
  handleSubmit,
  selectedCourseId,
}) => {
  if (selectedCourseId) {
    return (
      <Grid container justify="space-between">
        <Grid item>
          {activeTab > 0 && (
            <Button
              onClick={() =>
                change(EMPLOYEE_COURSE_FORM.ACTIVE_TAB, activeTab - 1)
              }
            >
              Previous
            </Button>
          )}
        </Grid>
        {activeTab < tabs.length - 1 && (
          <Grid item>
            <Button
              onClick={() =>
                change(EMPLOYEE_COURSE_FORM.ACTIVE_TAB, activeTab + 1)
              }
            >
              Next
            </Button>
          </Grid>
        )}
        {activeTab === tabs.length - 1 && (
          <Grid item>
            <LoadingButton
              type="submit"
              color="primary"
              disabled={!valid || submitting}
              loading={submitting}
              variant="contained"
              onClick={handleSubmit}
            >
              {submitText}
            </LoadingButton>
          </Grid>
        )}
      </Grid>
    );
  }

  return null;
};

export default compose()(EmployeeCourseModalActions);
